/**
 * Utility functions for layout components.
 * Separated to avoid fast refresh issues (fast refresh only works when a file exports components).
 */

/**
 * Determine if the budget alert banner should be shown for the current path.
 * Connector setup/edit flows are focused forms. Suppress unrelated global cost fetches
 * here to avoid noisy background requests while configuring resources.
 */
export function shouldShowBudgetAlertBanner(pathname: string): boolean {
  return !pathname.startsWith('/governance/resources/connect/')
}

/**
 * Determine if the ingestion health banner should be shown for the current
 * path (agion/Agion#2091).
 *
 * Suppressed in the connector setup flow for the same reason as the budget
 * banner: it is a focused form, and an organization-wide fan-out read behind
 * it is noise. Suppressed on a capsule's own management page because that page
 * already states the capsule's health in full, including the failure code.
 */
export function shouldShowIngestionHealthBanner(pathname: string): boolean {
  if (pathname.startsWith('/governance/resources/connect/')) return false
  return !/^\/intelligence\/capsules\/[^/]+/.test(pathname)
}
